export default __webpack_public_path__ + "static/media/04AW1MAR66.319f5968.jpg";